import { render } from "./CameraSurface.vue?vue&type=template&id=72ad0b54"
import script from "./CameraSurface.vue?vue&type=script&lang=ts"
export * from "./CameraSurface.vue?vue&type=script&lang=ts"

import "./CameraSurface.vue?vue&type=style&index=0&id=72ad0b54&lang=scss"
script.render = render

export default script